import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { Dropdown } from 'primereact/dropdown';
import { AutoComplete } from "primereact/autocomplete";
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import { Image } from "primereact/image";
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from 'primereact/inputnumber'; // NOVO: para campos numéricos
import Utils from "../../utilities/Utils";
import EmpresaService from "../../service/EmpresaService";
import EmpresaCategoriaService from "../../service/EmpresaCategoriaService";
import EnderecoService from "../../service/EnderecoService";

const empresaService = new EmpresaService();
const empresaCategoriaService = new EmpresaCategoriaService();
const enderecoService = new EnderecoService();

const BOOKING_BASE_URL = 'https://agendamento.starblack.app.br';
const RESERVED_COMPANY_SLUGS = new Set([
    'admin', 'api', 'agendamento', 'cadastro', 'entrar', 'manifest', 'perfil'
]);

const slugifyCompanyName = (value) => {
    const slug = String(value || 'empresa')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 110);

    return !slug || RESERVED_COMPANY_SLUGS.has(slug)
        ? `empresa-${slug || 'starblack'}`
        : slug;
};

const CadastrarEmpresa = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();
    let empresaNovo = {
        categoria: null,
        categoria_id: null,
        ipagId: null,
        name: '',
        document: '',
        cnae: '',
        razaoSocial: '',
        telefone: '',
        endereco: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        numero: '',
        latitude: null,
        longitude: null,
        file: '',
        percentualServico: null,
        taxaFixaServico: null,
        providerCanPauseOwnSchedule: false,
    };
    const [empresa, setEmpresa] = useState(empresaNovo);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [categoria, setCategoria] = useState();
    const [selectedCategoria, setSelectedCategoria] = useState(null);
    const [bancoSelecionado, setBancoSelecionado] = useState(null);
    const [cidades, setCidades] = useState([]);
    const [estados, setEstados] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [cidadesFilteredValue, setCidadesFilteredValue] = useState([]);
    const [estadosFilteredValue, setEstadosFilteredValue] = useState([]);
    const [bancosFilteredValue, setBancosFilteredValue] = useState([]);
    const [isCpf, setIsCpf] = useState(false);
    const [cidade, setCidade] = useState(null);
    const [estado, setEstado] = useState(null);
    const [banco, setBanco] = useState(null);
    const [avatar, setAvatar] = useState()
    const [imageLoading, setImageLoading] = useState(true);
    const [formData, setFormData] = useState(new FormData())
    const [dataLoaded, setDataLoaded] = useState(false);
    const [isSignature, setIsSignature] = useState(false);
    const fileUploadRef = useRef(null);
    const { id } = useParams();
    const bookingSlug = empresa.slug || (empresa.name ? slugifyCompanyName(empresa.name) : '');
    const bookingUrl = bookingSlug ? `${BOOKING_BASE_URL}/${bookingSlug}` : `${BOOKING_BASE_URL}/`;

    const copyBookingUrl = async () => {
        try {
            await navigator.clipboard.writeText(bookingUrl);
            showToast({ severity: 'success', summary: 'Link copiado', detail: 'O endereço de agendamento foi copiado.' });
        } catch (error) {
            showToast({ severity: 'error', summary: 'Erro', detail: 'Não foi possível copiar o endereço.' });
        }
    };

    const [tipoTaxa, setTipoTaxa] = useState('percentual');
    const [percentualServico, setPercentualServico] = useState(null);
    const [taxaFixaServico, setTaxaFixaServico] = useState(null);

    const opcoesPercentual = [
        { label: 'Padrão (0% + R$ 10,00)', value: 'padrao' },
        { label: '10%', value: 10 },
        { label: '50%', value: 50 },
        { label: '100%', value: 100 }
    ];

    const [percentualSelecionado, setPercentualSelecionado] = useState(null);

    const initCategoria = useCallback(async () => {
        setLoading(true);
        try {
            const data = await empresaCategoriaService.listCategoriaEmpresas(iss);
            const updatedItems = data.data.rows.map(({ url, excluido, ...rest }) => rest);
            setCategoria(updatedItems);
        } catch (error) {
            console.error("Erro ao carregar categorias:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar categorias' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    const initBanks = useCallback(async () => {
        try {
            const data = await empresaService.listAllBanks();
            const bancosValidos = data.data.filter(banco =>
                banco.code !== null &&
                banco.code !== undefined &&
                banco.code !== '' &&
                !isNaN(banco.code)
            );
            setBancos(bancosValidos);
        } catch (error) {
            console.error("Erro ao carregar lista de bancos:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar lista de bancos' });
        } finally {
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        initCategoria();
        initBanks();
    }, [initCategoria, initBanks]);

    useEffect(() => {
        const loadCompanyData = async () => {
            if (id && !dataLoaded) {
                try {
                    setLoading(true);
                    setImageLoading(true);
                    let documentFormatted = ''
                    const data = await empresaService.getEmpresa(iss, id);
                    const empresaNovo = data.data.rows[0];
                    const settingsResponse = await empresaService.getCompanySettings(iss, id);
                    empresaNovo.providerCanPauseOwnSchedule = Boolean(
                        settingsResponse.data.providerCanPauseOwnSchedule
                    );
                    empresaNovo.dataNascimentoDoProprietario = Utils.formatData(empresaNovo.dataNascimentoDoProprietario)
                    const categoria = {
                        id: empresaNovo.categoriaCompany.id,
                        nome: empresaNovo.categoriaCompany.nome,
                        descricao: empresaNovo.categoriaCompany.descricao
                    };
                    if (empresaNovo.document.length <= 11) {
                        documentFormatted = empresaNovo.document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
                        setIsCpf(true)
                    } else if (empresaNovo.document.length === 14) {
                        documentFormatted = empresaNovo.document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
                    }
                    empresaNovo.document = documentFormatted;
                    setAvatar(empresaNovo.url)
                    formData.append('url', empresaNovo.url)
                    setImageLoading(false);
                    setSelectedCategoria(categoria)

                    if (empresaNovo.ipagSyncStatus === 'signature') {
                        setIsSignature(true);
                    }

                    if (empresaNovo.servicoEmpresaTaxas && empresaNovo.servicoEmpresaTaxas.length > 0) {
                        const taxa = empresaNovo.servicoEmpresaTaxas[0];
                        if (taxa.percentualServico > 0) {
                            // Verifica qual opção do dropdown corresponde ao valor
                            const opcao = opcoesPercentual.find(opt => opt.value === parseInt(taxa.percentualServico));
                            setPercentualSelecionado(opcao['value'] || opcoesPercentual[0]);
                            setPercentualServico(parseInt(taxa.percentualServico));
                            setTipoTaxa('percentual');
                            setTaxaFixaServico(0);
                        } else if (taxa.percentualServico === 0 && taxa.taxaFixaServico === 10) {
                            // Caso especial: padrão (0% + R$ 10,00)
                            setPercentualSelecionado(opcoesPercentual[0]);
                            setPercentualServico(0);
                            setTipoTaxa('percentual');
                            setTaxaFixaServico(10);
                        } else if (taxa.taxaFixaServico > 0) {
                            setTaxaFixaServico(taxa.taxaFixaServico);
                            setTipoTaxa('fixa');
                            setPercentualServico(null);
                            setPercentualSelecionado(null);
                        }
                    }

                    setTimeout(() => {
                        setEmpresa(empresaNovo);
                    }, 200);
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        }
        loadCompanyData();
    }, [dataLoaded, formData, id, iss, bancos]);

    useEffect(() => {
        if (bancos && bancos.length > 0 && empresa.banco) {
            const bancoEncontrado = bancos.find(b => b.code.toString() === empresa.banco.toString());
            if (bancoEncontrado) {
                setBancoSelecionado(bancoEncontrado);
            } else {
                console.warn(`Banco com código ${empresa.banco} não encontrado na lista de ${bancos.length} bancos`);
            }
        }
    }, [bancos, empresa]);

    const onUpload = (e) => {
        setLoading(true);
        setImageLoading(true);
        formData.delete('url');
        formData.append('file', e.files[0]);
        setFormData(formData)
        fileUploadRef.current.clear();
        setAvatar(e.files[0].objectURL);
        setLoading(false);
    }

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        if (checkbox) {
            val = e.value;
        }
        if (name === 'document') {
            let c = String(val).replace(/[^\d]/g, '')
            if (c.length == 14 && !Utils.validaCNPJ(c)) {
                showToast({ severity: 'error', summary: 'Error', detail: 'CNPJ inválido' });
                return;
            }
            val = Utils.formatCnpj(val);
        }
        if (name === 'categoria_id') {
            setSelectedCategoria(e.value)
            val = e.value.id;
        }
        if (name === 'banco') {
            setBancoSelecionado(e.value);
            val = e.value.code;
        }
        let _empresa = { ...empresa };
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            if (!_empresa[parent]) {
                _empresa[parent] = {};
            }
            _empresa[parent][child] = val;
        } else {
            if (list) {
                _empresa[name] = val;
            } else {
                _empresa[name] = val;
            }
        }
        setEmpresa(_empresa);
    }

    function removeDuplicatesById(arr) {
        const idCounts = new Map();
        arr.forEach(item => {
            if (idCounts.has(item.id)) {
                idCounts.set(item.id, idCounts.get(item.id) + 1);
            } else {
                idCounts.set(item.id, 1);
            }
        });
        return arr.filter(item => idCounts.get(item.id) === 1);
    }

    const validarTaxas = () => {
        // Se o tipo é percentual
        if (tipoTaxa === 'percentual') {
            // Verifica se o dropdown foi selecionado
            if (percentualSelecionado === null || percentualSelecionado === undefined) {
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Selecione uma opção de percentual.'
                });
                return false;
            }

            // Se for 'padrao', os valores já estão definidos (0% e R$ 10,00)
            if (percentualSelecionado === 'padrao') {
                return true;
            }

            // Valida percentual (0-100) - garantia extra
            if (percentualServico !== null && (percentualServico < 0 || percentualServico > 100)) {
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Percentual de serviço deve estar entre 0 e 100.'
                });
                return false;
            }
        }

        // Se o tipo é fixa
        if (tipoTaxa === 'fixa') {
            if (taxaFixaServico === null || taxaFixaServico === undefined) {
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Informe o valor da taxa fixa.'
                });
                return false;
            }

            if (taxaFixaServico < 0) {
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Taxa fixa de serviço não pode ser negativa.'
                });
                return false;
            }
        }

        return true;
    }

    const cadastrar = () => {
        setSubmitted(true);

        const camposObrigatorios = empresa.categoria_id &&
            empresa.name &&
            empresa.telefone &&
            empresa.cep &&
            empresa.endereco &&
            empresa.cidade &&
            empresa.estado &&
            avatar &&
            (isCpf || (empresa.razaoSocial && empresa.cnae));

        const bancosValidos = isSignature || bancoSelecionado;

        if (camposObrigatorios && bancosValidos) {
            let _empresa = { ...empresa };
            _empresa.document = String(empresa.document).replace(/[^\d]/g, '')
            _empresa.cpfDoProprietario = String(empresa.cpfDoProprietario).replace(/[^\d]/g, '')
            _empresa.isSignature = isSignature ? 1 : 0;


            if (!isSignature) {
                if (!validarTaxas()) {
                    return;
                }
                if (tipoTaxa === 'percentual') {
                    if (percentualSelecionado === 'padrao') {
                        _empresa.percentualServico = 0;
                        _empresa.taxaFixaServico = 10;
                    } else {
                        _empresa.percentualServico = percentualServico;
                        _empresa.taxaFixaServico = null;
                    }
                } else if (tipoTaxa === 'fixa') {
                    _empresa.percentualServico = null;
                    _empresa.taxaFixaServico = taxaFixaServico;
                } else {
                    // Fallback: valores padrão
                    _empresa.percentualServico = null;
                    _empresa.taxaFixaServico = null;
                }
                _empresa.banco = bancoSelecionado ? bancoSelecionado.code : null;
            } else {
                delete _empresa.banco;
                delete _empresa.agencia;
                delete _empresa.conta;
                delete _empresa.percentualServico;
                delete _empresa.taxaFixaServico;
            }

            const fileValue = formData.get('file');
            const newFormData = new FormData();
            if (fileValue) {
                _empresa.url = '';
                newFormData.append('file', fileValue);
            }
            Object.entries(_empresa).forEach(([chave, valor]) => {
                if (valor !== null && valor !== undefined) {
                    newFormData.append(chave, valor);
                }
            });

            setLoading(true)
            if (empresa.id != null) {
                empresaService.putEmpresa(iss, newFormData, empresa.id).then(async data => {
                    await empresaService.putCompanySettings(iss, empresa.id, {
                        providerCanPauseOwnSchedule: Boolean(empresa.providerCanPauseOwnSchedule)
                    });
                    showToast({ severity: 'success', summary: 'Cadastro de empresa', detail: 'Empresa editada com sucesso' });
                    history.push('/empresa/listar');
                    return;
                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            } else {
                empresaService.postEmpresa(iss, newFormData).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de empresa', detail: 'Empresa cadastrada com sucesso' });
                    history.push('/empresa/listar');
                    return;
                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }
        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos e inserir uma imagem' });
        }
    }

    const searchBanco = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setBancosFilteredValue([...bancos]);
            }
            else {
                setBancosFilteredValue(bancos.filter((banco) => {
                    return banco.name.toLowerCase().includes(event.query.toLowerCase());
                }));
            }
        }, 250);
    }

    const searchCidade = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setCidadesFilteredValue([...cidades]);
            }
            else {
                setCidadesFilteredValue(cidades.filter((cidade) => {
                    return cidade.nome.toLowerCase().includes(event.query.toLowerCase());
                }));
            }
        }, 250);
    }

    const searchEstado = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setEstadosFilteredValue([...estados]);
            }
            else {
                setEstadosFilteredValue(estados.filter((estado) => {
                    return estado.nome.toLowerCase().includes(event.query.toLowerCase()) || estado.name.toLowerCase().includes(event.query.toLowerCase());
                }));
            }
        }, 250);
    }

    const handleKeyDown = (event, name) => {
        const { key } = event;
        const lastValue = empresa[name] || '';
        let _empresa = { ...empresa };
        if (key === 'Backspace') {
            const input = event.target;
            let cursorPos = input.selectionStart;
            if (cursorPos > 0 && (input.value[cursorPos - 1] === '.' || input.value[cursorPos - 1] === '-')) {
                event.preventDefault();
                let newValue = lastValue.substring(0, cursorPos - 1) + lastValue.substring(cursorPos);
                newValue = newValue.replace(/\D/g, '');
                _empresa.document = Utils.formatCnpj(newValue);
                setEmpresa(_empresa);
            }
        }
    };

    const searchByCep = (cep) => {
        if (cep.length === 9) {
            enderecoService.getEnderecoPorCEP(cep).then(data => {
                let endereco = data.data;
                let _empresa = { ...empresa };
                _empresa.endereco = endereco.logradouro ? endereco.logradouro.toUpperCase() : "";
                _empresa.bairro = endereco.bairro ? endereco.bairro.toUpperCase() : "";
                _empresa.cidade = endereco.localidade ? endereco.localidade.toUpperCase() : "";
                _empresa.estado = endereco.uf ? endereco.uf.toUpperCase() : "";
                setEmpresa(_empresa);
            }, error => {
                showToast({ severity: 'error', summary: 'Erro ao buscar endereço', detail: 'Erro ao buscar endereço pelo cep' });
            });
        }
    }

    const verificaSeExisteCnpj = () => {
        let c = String(empresa.document).replace(/[^\d]/g, '')
        if (c.length == 14 || c.length == 11) {
            setLoading(true);
            empresaService.getEmpresaPorCnpj(iss, empresa.document).then(data => {
                setLoading(false);
                if (data.status === 409) {
                    showToast({ severity: 'error', summary: 'Conflito', detail: 'CNPJ ou CPF já cadastrado' });
                }
            }, error => {
                setLoading(false);
                if (error.response.status === 409) {
                    showToast({ severity: 'error', summary: 'Conflito', detail: 'CNPJ ou CPF já cadastrado' });
                }
            });
        }
    };

    const verificaSeExisteCnae = () => {
        let cnaeFormatado = String(empresa.cnae).replace(/[^\d]/g, '');
        if (cnaeFormatado.length === 7) {
            setLoading(true);
            empresaService.getMccByCnae(iss, cnaeFormatado).then(data => {
                setLoading(false);
                if (data.data && data.data.message.exists === false) {
                    showToast({
                        severity: 'warn',
                        summary: 'CNAE não encontrado',
                        detail: 'O CNAE informado não está cadastrado no sistema. Verifique o código.'
                    });
                }
            }, error => {
                setLoading(false);
                if (error.response && error.response.status === 404) {
                    showToast({
                        severity: 'warn',
                        summary: 'CNAE não encontrado',
                        detail: 'O CNAE informado não está cadastrado no sistema. Verifique o código.'
                    });
                }
            });
        }
    };

    // NOVO: Handler para mudança de tipo de taxa
    const handleTipoTaxaChange = (tipo) => {
        setTipoTaxa(tipo);
        if (tipo === 'percentual') {
            setTaxaFixaServico(null);
            // Reseta o dropdown para o primeiro valor (Padrão)
            setPercentualSelecionado(opcoesPercentual[0]);
            setPercentualServico(0);
            setTaxaFixaServico(10);
        } else {
            setPercentualServico(null);
            setPercentualSelecionado(null);
        }
    };

    // NOVO: Handler para mudança do dropdown de percentual
    const handlePercentualChange = (e) => {
        const valor = e.value;
        setPercentualSelecionado(valor);

        if (valor === 'padrao') {
            setPercentualServico(0);
            setTaxaFixaServico(10);
        } else {
            setPercentualServico(valor);
            setTaxaFixaServico(0);
            setTipoTaxa('percentual');
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <div>Informações da empresa</div>
                {empresa.id && empresa.ipagId && (
                    <div style={{
                        backgroundColor: '#e3f2fd',
                        color: '#1976d2',
                        padding: '8px 16px',
                        borderRadius: '20px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        border: '1px solid #bbdefb'
                    }}>
                        Código IPag: {empresa.ipagId}
                    </div>
                )}
            </div>
            <div>
                <div className="grid">
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                        <div style={{
                            width: 160,
                            height: 160,
                            border: 'solid',
                            borderWidth: '0.5px',
                            borderRadius: '8px',
                            borderColor: 'rgba(255,255,255,0.35)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            position: 'relative'
                        }} >
                            {imageLoading && avatar && (
                                <div style={{
                                    position: 'absolute',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px'
                                }}>
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', color: '#6366f1' }}></i>
                                </div>
                            )}
                            <Image
                                src={avatar}
                                alt="Image"
                                width="150"
                                height="auto"
                                onLoad={() => setImageLoading(false)}
                                onError={() => setImageLoading(false)}
                                style={{ opacity: imageLoading ? 0.3 : 1, transition: 'opacity 0.3s' }}
                            />
                        </div>
                    </div>
                    <div className="col-12 p-0" aria-hidden="true"></div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <h5>Adicionar/Alterar</h5>
                        <FileUpload loading={loading} ref={fileUploadRef} className="mr-2 mb-2"
                            chooseLabel={'Imagem'}
                            mode="basic"
                            name="avatar[]"
                            customUpload={true}
                            auto={true}
                            uploadHandler={onUpload} accept="image/*" maxFileSize={10000000} />
                    </div>
                </div>
                <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                    <div className="col-12 p-0" aria-hidden="true"></div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                        <span className="p-float-label">
                            <InputText
                                onBlur={() => {
                                    verificaSeExisteCnpj();
                                    const value = empresa.document.replace(/[^\d]/g, '');
                                    setIsCpf(value.length > 0 && value.length <= 11);
                                    if (value.length <= 11) {
                                        const formatted = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
                                        onInputChange({ target: { value: formatted } }, 'document');
                                    } else if (value.length === 14) {
                                        const formatted = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
                                        onInputChange({ target: { value: formatted } }, 'document');
                                    }
                                }}
                                onKeyDown={handleKeyDown}
                                value={empresa.document}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^\d]/g, '');
                                    if (value.length <= 14) {
                                        onInputChange({ target: { value: value } }, 'document');
                                    }
                                }}
                                required
                                className={classNames({ 'p-invalid': submitted && !empresa.document })}
                                id="document"
                                type="text"
                                maxLength="14"
                            />
                            <label htmlFor="document">CPF/CNPJ</label>
                        </span>
                        {submitted && !empresa.document && <small className="p-invalid">CPF/CNPJ é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                        <span className="p-float-label">
                            <InputMask
                                value={empresa.cnae}
                                onChange={(e) => onInputChange(e, 'cnae')}
                                onBlur={() => verificaSeExisteCnae()}
                                className={classNames({ 'p-invalid': submitted && !empresa.cnae && !isCpf })}
                                required={!isCpf}
                                mask="9999999"
                                id="cnae"
                                type="text"
                                disabled={isCpf}
                            />
                            <label htmlFor="cnae">CNAE</label>
                        </span>
                        {submitted && !empresa.cnae && !isCpf && <small className="p-invalid">CNAE é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-3">
                        <span className="p-float-label">
                            <InputText onKeyDown={handleKeyDown} value={empresa.name} onChange={(e) => onInputChange(e, 'name')} required
                                className={classNames({ 'p-invalid': submitted && !empresa.name })} id="name" type="text" />
                            <label htmlFor="name">Nome fantasia</label>
                        </span>
                        {submitted && !empresa.name && <small className="p-invalid">Nome Fantasia é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-5">
                        {/* <label htmlFor="bookingUrl">Link de agendamento</label> */}
                        <div className="p-inputgroup">
                            <InputText id="bookingUrl" value={bookingUrl} readOnly aria-label="Link de agendamento da empresa" />
                            <Button type="button" icon="pi pi-copy" label="Copiar" onClick={copyBookingUrl} disabled={!empresa.name && !empresa.slug} aria-label="Copiar link de agendamento" />
                        </div>
                        {!empresa.id && empresa.name && <small className="text-color-secondary">Prévia do endereço. O link definitivo será confirmado ao salvar.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12">
                        <span className="p-float-label">
                            <InputText onKeyDown={handleKeyDown} value={empresa.razaoSocial} onChange={(e) => onInputChange(e, 'razaoSocial')} required={!isCpf}
                                className={classNames({ 'p-invalid': submitted && !empresa.razaoSocial && !isCpf })} id="razaoSocial" type="text" disabled={isCpf} />
                            <label htmlFor="razaoSocial">Razão social</label>
                        </span>
                        {submitted && !empresa.razaoSocial && !isCpf && <small className="p-invalid">Razão Social é obrigatória.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                        <span className="p-float-label">
                            <InputText onKeyDown={handleKeyDown} value={empresa.email} onChange={(e) => onInputChange(e, 'email')} required={!isCpf}
                                className={classNames({ 'p-invalid': submitted && !empresa.email && !isCpf })} id="email" type="email" disabled={isCpf} />
                            <label htmlFor="email">Email da empresa</label>
                        </span>
                        {submitted && !empresa.email && !isCpf && <small className="p-invalid">Email é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                        <span className="p-float-label">
                            <InputMask value={empresa.telefone}
                                onChange={(e) => onInputChange(e, 'telefone')}
                                className={classNames({ 'p-invalid': submitted && !empresa.telefone })} required
                                mask={"(99) 9999-9999"}
                                id="telefone" type="text" />
                            <label htmlFor="telefone">Telefone</label>
                        </span>
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                        <span className="p-float-label">
                            <InputMask value={empresa.cep} onChange={(e) => {
                                onInputChange(e, 'cep')
                            }}
                                onBlur={(e) => searchByCep(e.target.value)}
                                className={classNames({ 'p-invalid': submitted && !empresa.cep })} required
                                mask="99999-999" id="cep" type="text" />
                            <label htmlFor="cep">CEP</label>
                        </span>
                        {submitted && !empresa.cep && <small className="p-invalid">Cep é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                        <span className="p-float-label">
                            <InputText value={empresa.endereco} onChange={(e) => onInputChange(e, 'endereco')}
                                className={classNames({ 'p-invalid': submitted && !empresa.endereco })} required
                                id="endereco" type="text" />
                            <label htmlFor="endereco">Endereço</label>
                        </span>
                        {submitted && !empresa.endereco && <small className="p-invalid">Endereco é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                        <span className="p-float-label">
                            <InputText value={empresa.numero} onChange={(e) => onInputChange(e, 'numero')}
                                className={classNames({ 'p-invalid': submitted && !empresa.numero })} required
                                id="numero" type="text" />
                            <label htmlFor="numero">Número</label>
                        </span>
                        {submitted && !empresa.numero && <small className="p-invalid">Número é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                        <span className="p-float-label">
                            <InputText value={empresa.complemento} onChange={(e) => onInputChange(e, 'complemento')}
                                id="complemento" type="text" />
                            <label htmlFor="complemento">Complemento</label>
                        </span>
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <span className="p-float-label">
                            <AutoComplete value={empresa.cidade} onChange={(e) => onInputChange(e, 'endereco.cidade')}
                                className={classNames({ 'p-invalid': submitted && !empresa.cidade })}
                                placeholder="" id="cidade" dropdown
                                suggestions={cidadesFilteredValue} completeMethod={searchCidade}
                                field="nome" forceSelection disabled />
                            <label htmlFor="cidade">Cidade</label>
                        </span>
                        {submitted && !empresa.cidade && <small className="p-invalid">Cidade é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <span className="p-float-label">
                            <AutoComplete placeholder="" id="estado" dropdown
                                value={empresa.estado} onChange={(e) => onInputChange(e, 'estado')}
                                className={classNames({ 'p-invalid': submitted && !empresa.estado })} suggestions={estadosFilteredValue} completeMethod={searchEstado}
                                field="nome" forceSelection disabled />
                            <label htmlFor="estado">Estado</label>
                        </span>
                        {submitted && !empresa.estado && <small className="p-invalid">Estado é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <span className="p-float-label">
                            <Dropdown optionLabel="nome" value={selectedCategoria}
                                className={classNames({ 'p-invalid': submitted && !empresa.categoria_id })}
                                options={categoria}
                                onChange={(e) => {
                                    onInputChange(e, 'categoria_id')
                                }} />
                            <label htmlFor="categoria_id">Categoria</label>
                        </span>
                        {submitted && !selectedCategoria &&
                            <small className="p-invalid">Categoria é obrigatório.</small>}
                    </div>

                    {/* Seção de dados do proprietário */}
                    <div style={{ marginTop: 20, marginBottom: 10 }} className="field col-12">
                        <h4>Dados do Proprietário</h4>
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                        <span className="p-float-label">
                            <InputText value={empresa.nomeDoProprietario} onChange={(e) => onInputChange(e, 'nomeDoProprietario')}
                                className={classNames({ 'p-invalid': submitted && !empresa.nomeDoProprietario })} required
                                id="nomeDoProprietario" type="text" />
                            <label htmlFor="nomeDoProprietario">Nome do proprietário</label>
                        </span>
                        {submitted && !empresa.nomeDoProprietario && <small className="p-invalid">Nome do proprietário é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                        <span className="p-float-label">
                            <InputText value={empresa.emailDoProprietario} onChange={(e) => onInputChange(e, 'emailDoProprietario')}
                                className={classNames({ 'p-invalid': submitted && !empresa.emailDoProprietario })} required
                                id="emailDoProprietario" type="email" />
                            <label htmlFor="emailDoProprietario">Email do proprietário</label>
                        </span>
                        {submitted && !empresa.emailDoProprietario && <small className="p-invalid">Email do proprietário é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <span className="p-float-label">
                            <InputMask value={empresa.cpfDoProprietario} onChange={(e) => onInputChange(e, 'cpfDoProprietario')}
                                className={classNames({ 'p-invalid': submitted && !empresa.cpfDoProprietario })} required
                                mask="999.999.999-99" id="cpfDoProprietario" type="text" />
                            <label htmlFor="cpfDoProprietario">CPF do proprietário</label>
                        </span>
                        {submitted && !empresa.cpfDoProprietario && <small className="p-invalid">CPF do proprietário é obrigatório.</small>}
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <span className="p-float-label">
                            <InputMask value={empresa.contatoDoProprietario} onChange={(e) => onInputChange(e, 'contatoDoProprietario')}
                                className={classNames({ 'p-invalid': submitted && !empresa.contatoDoProprietario })} required
                                mask="(99) 99999-9999" id="contatoDoProprietario" type="text" />
                            <label htmlFor="contatoDoProprietario">Contato do proprietário</label>
                        </span>
                    </div>
                    <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                        <span className="p-float-label">
                            <InputMask value={empresa.dataNascimentoDoProprietario} onChange={(e) => onInputChange(e, 'dataNascimentoDoProprietario')}
                                className={classNames({ 'p-invalid': submitted && !empresa.dataNascimentoDoProprietario })} required
                                mask="99/99/9999" id="dataNascimentoDoProprietario" type="text" />
                            <label htmlFor="dataNascimentoDoProprietario">Data de nascimento</label>
                        </span>
                    </div>

                    {/* ───────────────────────────────────── */}
                    {/* Toggle de assinatura                 */}
                    {/* ───────────────────────────────────── */}
                    <div style={{ marginTop: 20, marginBottom: 10 }} className="field col-12">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <InputSwitch
                                checked={isSignature}
                                onChange={(e) => {
                                    setIsSignature(e.value);
                                }}
                                id="isSignature"
                            />
                            <label htmlFor="isSignature" style={{ fontWeight: 'bold', cursor: 'pointer', margin: 0 }}>
                                {isSignature ? 'Empresa de Assinatura' : 'Empresa de Assinatura'}
                            </label>
                            {isSignature && (
                                <span style={{
                                    backgroundColor: '#fff3e0',
                                    color: '#e65100',
                                    padding: '4px 10px',
                                    borderRadius: '12px',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    Dados bancários e taxas de serviço não serão exigidos
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Seção bancária CONDICIONAL */}
                    {!isSignature && (
                        <>
                            {/* ───────────────────────────────────── */}
                            {/* NOVA: Seção de Taxas de Serviço        */}
                            {/* ───────────────────────────────────── */}
                            <div style={{ marginTop: 20, marginBottom: 10 }} className="field col-12">
                                <h4>Taxas de Serviço</h4>
                                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                                    Escolha entre Percentual ou Taxa Fixa. Não é permitido preencher ambos.
                                </div>
                            </div>

                            <div style={{ marginTop: 10 }} className="field col-12">
                                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <input
                                            type="radio"
                                            id="taxaPercentual"
                                            name="tipoTaxa"
                                            value="percentual"
                                            checked={tipoTaxa === 'percentual'}
                                            onChange={() => handleTipoTaxaChange('percentual')}
                                        />
                                        <label htmlFor="taxaPercentual" style={{ cursor: 'pointer' }}>Percentual do Serviço</label>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <input
                                            type="radio"
                                            id="taxaFixa"
                                            name="tipoTaxa"
                                            value="fixa"
                                            checked={tipoTaxa === 'fixa'}
                                            onChange={() => handleTipoTaxaChange('fixa')}
                                        />
                                        <label htmlFor="taxaFixa" style={{ cursor: 'pointer' }}>Taxa Fixa do Serviço</label>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                                <span className="p-float-label">
                                    <Dropdown
                                        value={percentualSelecionado}
                                        options={opcoesPercentual}
                                        onChange={handlePercentualChange}
                                        className={classNames({
                                            'p-invalid': submitted && tipoTaxa === 'percentual' &&
                                                (percentualSelecionado === null || percentualSelecionado === undefined)
                                        })}
                                        id="percentualServico"
                                        placeholder="Selecione o percentual"
                                        disabled={tipoTaxa !== 'percentual'}
                                        optionLabel="label"
                                        style={{ width: '100%' }}
                                    />
                                    <label htmlFor="percentualServico">Percentual do Serviço</label>
                                </span>
                                {submitted && tipoTaxa === 'percentual' &&
                                    (percentualSelecionado === null || percentualSelecionado === undefined) &&
                                    <small className="p-invalid">Percentual do serviço é obrigatório.</small>
                                }
                                {percentualSelecionado === 'padrao' && (
                                    <small style={{ color: '#666', display: 'block', marginTop: '4px' }}>
                                        Padrão: 0% de percentual + R$ 10,00 de taxa fixa
                                    </small>
                                )}
                            </div>

                            <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                                <span className="p-float-label">
                                    <InputNumber
                                        value={taxaFixaServico}
                                        onValueChange={(e) => {
                                            setTaxaFixaServico(e.value);
                                            if (e.value !== null && e.value !== undefined) {
                                                setTipoTaxa('fixa');
                                                setPercentualServico(null);
                                            }
                                        }}
                                        className={classNames({
                                            'p-invalid': submitted && tipoTaxa === 'fixa' &&
                                                (taxaFixaServico === null || taxaFixaServico === undefined)
                                        })}
                                        id="taxaFixaServico"
                                        mode="currency"
                                        currency="BRL"
                                        locale="pt-BR"
                                        min={0}
                                        step={0.01}
                                        disabled={tipoTaxa !== 'fixa'}
                                        placeholder="R$ 0,00"
                                    />
                                    <label htmlFor="taxaFixaServico">Taxa Fixa do Serviço (R$)</label>
                                </span>
                                {submitted && tipoTaxa === 'fixa' &&
                                    (taxaFixaServico === null || taxaFixaServico === undefined) &&
                                    <small className="p-invalid">Taxa fixa do serviço é obrigatória.</small>
                                }
                                {taxaFixaServico !== null && taxaFixaServico !== undefined && taxaFixaServico < 0 &&
                                    <small className="p-invalid">Taxa fixa não pode ser negativa.</small>
                                }
                            </div>
                            <div style={{ marginTop: 20, marginBottom: 10 }} className="field col-12">
                                <h4>Dados Bancários</h4>
                            </div>
                            <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                                <span className="p-float-label">
                                    <AutoComplete
                                        value={bancoSelecionado}
                                        onChange={(e) => onInputChange(e, 'banco')}
                                        className={classNames({ 'p-invalid': submitted && !empresa.banco })}
                                        placeholder=""
                                        id="banco"
                                        dropdown
                                        suggestions={bancosFilteredValue}
                                        completeMethod={searchBanco}
                                        field="name"
                                        itemTemplate={(item) => (
                                            <div>
                                                <strong>{item.code}</strong> - {item.name}
                                            </div>
                                        )}
                                        selectedItemTemplate={(item) => (
                                            item ? `${item.code} - ${item.name}` : ''
                                        )}
                                    />
                                    <label htmlFor="banco">Banco</label>
                                </span>
                            </div>
                            <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                                <span className="p-float-label">
                                    <InputText value={empresa.agencia} onChange={(e) => onInputChange(e, 'agencia')}
                                        className={classNames({ 'p-invalid': submitted && !empresa.agencia })} required
                                        id="agencia" type="text" />
                                    <label htmlFor="agencia">Agência</label>
                                </span>
                            </div>
                            <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                                <span className="p-float-label">
                                    <InputText value={empresa.conta} onChange={(e) => onInputChange(e, 'conta')}
                                        className={classNames({ 'p-invalid': submitted && !empresa.conta })} required
                                        id="conta" type="text" />
                                    <label htmlFor="conta">Conta</label>
                                </span>
                            </div>
                        </>
                    )}

                    <div className='field col-12'>
                        <h4>Configurações da Empresa</h4>
                        <p>Defina como os profissionais podem gerenciar a agenda nesta empresa.</p>
                        <div className='flex align-items-center gap-3'>
                            <InputSwitch
                                checked={Boolean(empresa.providerCanPauseOwnSchedule)}
                                onChange={(e) => onInputChange(e, 'providerCanPauseOwnSchedule', false, true)}
                                id='providerCanPauseOwnSchedule'
                            />
                            <div>
                                <label htmlFor='providerCanPauseOwnSchedule'>
                                    Permitir que profissionais pausem a própria agenda
                                </label>
                                <small className='block mt-1'>
                                    Administradores continuam podendo gerenciar as agendas independentemente desta opção.
                                </small>
                            </div>
                        </div>
                    </div>

                    <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                        onClick={cadastrar} className="mr-2 mb-2"></Button>
                    <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                        <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarEmpresa, comparisonFn);
